import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { getToken, getUser } from "../lib/authToken";
import { DEV_USER } from "../config/localAuth";

import Layout from "../components/layout/Layout";
import Dashboard from "../pages/Dashboard";
import Orders from "../pages/Orders";
import OrderDetails from "../pages/OrderDetails";
import Payments from "../pages/Payments";
import Menu from "../pages/Menu";

import Calendar from "../pages/Calendar";
import Home from "../components/landing/Home";
import SignIn from "../pages/SignIn";

import NotFound from "../pages/NotFound";
import LiveOrder from "../pages/LiveOrder";
import InventoryStock from "../pages/InventoryStock";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";
import ProductList from "../webview/pages/ProductList";
import Cart from "../webview/pages/Cart";
import PaymentSuccess from "../webview/pages/PaymentSuccess";
// import CarLoList from "../webview/pages/CarLoList";

function ProtectedRoute({ children }) {
  const token = getToken();
  return token ? children : <Navigate to="/signin" replace />;
}

// Role-based route guard - redirects non-admin users from restricted pages
function RoleGuard({ children, allowedRoles }) {
  const user = getUser() || DEV_USER;
  const userRole = user?.role;
  
  // If user role is not in allowedRoles, redirect to allowed page
  if (!allowedRoles.includes(userRole)) {
    // Non-admin users can only access Orders, Live Orders, and Menu
    return <Navigate to="/orders" replace />;
  }
  
  return children;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />

      <Route path="/home" element={<Home />} />
      <Route path="/partners/:restaurantId/products" element={<ProductList />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      {/* <Route path="/partners/:1006/carlo" element={<CarLoList />} /> */}

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <RoleGuard allowedRoles={['admin']}>
              <Layout>
                <Dashboard />
              </Layout>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <Layout>
              <Orders />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/l2/:orderId"
        element={
          <ProtectedRoute>
            <Layout>
              <OrderDetails />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/live-orders"
        element={
          <ProtectedRoute>
            <Layout>
              <LiveOrder />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <ProtectedRoute>
            <RoleGuard allowedRoles={['admin']}>
              <Layout>
                <Payments />
              </Layout>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/menu"
        element={
          <ProtectedRoute>
            <Layout>
              <Menu />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <ProtectedRoute>
            <Layout>
              <Calendar />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory-stock"
        element={
          <ProtectedRoute>
            <RoleGuard allowedRoles={['admin']}>
              <Layout>
                <InventoryStock />
              </Layout>
            </RoleGuard>
          </ProtectedRoute>
        }
      />

      <Route path="/signin" element={<SignIn />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
